import { render, staticRenderFns } from "./ChannelManagerKey.vue?vue&type=template&id=2c0551a6&"
import script from "./ChannelManagerKey.vue?vue&type=script&lang=js&"
export * from "./ChannelManagerKey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c0551a6')) {
      api.createRecord('2c0551a6', component.options)
    } else {
      api.reload('2c0551a6', component.options)
    }
    module.hot.accept("./ChannelManagerKey.vue?vue&type=template&id=2c0551a6&", function () {
      api.rerender('2c0551a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/ChannelManagerKey.vue"
export default component.exports